module.exports = __webpack_public_path__ + "static/media/15.0ea8b2fc.jpg";